// extracted by mini-css-extract-plugin
export var after = "DemoHorStyle-module--after--bfda6";
export var blockForm = "DemoHorStyle-module--blockForm--0db59";
export var btn = "DemoHorStyle-module--btn--bf160";
export var buttonSubmit = "DemoHorStyle-module--buttonSubmit--054c9";
export var check = "DemoHorStyle-module--check--80f8d";
export var customLabel = "DemoHorStyle-module--customLabel--093f2";
export var customPlaceholder = "DemoHorStyle-module--custom-placeholder--c99db";
export var disabled = "DemoHorStyle-module--disabled--3593f";
export var form = "DemoHorStyle-module--form--3622b";
export var formFluid = "DemoHorStyle-module--formFluid--4d545";
export var formNew = "DemoHorStyle-module--formNew--7116d";
export var hidden = "DemoHorStyle-module--hidden--1cdb0";
export var invalid = "DemoHorStyle-module--invalid--0265c";
export var lastDrop = "DemoHorStyle-module--lastDrop--b4d49";
export var legal = "DemoHorStyle-module--legal--36417";
export var required = "DemoHorStyle-module--required--4b93b";
export var success = "DemoHorStyle-module--success--980a5";
export var wrapperInputs = "DemoHorStyle-module--wrapperInputs--f4830";